import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AuthService } from '../../api/auth.service';
import { CreateNewModalComponent } from '../../modal/create-new-modal/create-new-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MustMatch } from './must-match.validator';


@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent implements OnInit {
  
  createNewPasswordForm: FormGroup;
  submitted = false;
  step: number;
  modalRef: any;
  userid: any;
  public checkUserAvailabilityStatus : boolean;

  security_q1_ans: true;
  security_q2_ans: true;
  security_q3_ans: true;
  security_q4_ans: true;


  constructor(
    private router: Router,
    private formBuilder: FormBuilder, private modalService: NgbModal,
    private authService: AuthService
  ) { }

  ngOnInit() {  
    this.createNewPasswordForm  =  this.formBuilder.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      user_id : ['']
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
    console.warn("resresresresresresres",localStorage.getItem('id'));

  }

  // convenience getter for easy access to form fields
 

  dateConvert(str: string | number | Date) {
    const date = new Date(str),
    mnth = ('0' + (date.getMonth() + 1)).slice(-2),
    day = ('0' + date.getDate()).slice(-2);
    return [mnth, day, date.getFullYear()].join('/');
  }
  continue() {
    this.submitted = false;

      this.createNewPasswordForm.value.user_id = localStorage.getItem('id');
      this.createNewPasswordForm.value.flag = false;
      if (this.createNewPasswordForm.invalid) {
        this.submitted = true;
        return;
      } else {
        this.authService.changePassword(  this.createNewPasswordForm.value ).subscribe(res => {
          this.modalRef = this.modalService.open(CreateNewModalComponent);
          this.modalRef.componentInstance.my_modal_content = 'password changed please login';
          this.modalRef.result.then((data: any) => {
          this.router.navigateByUrl('/login');
        });
          this.step ++;
        }, error => {
          this.modalRef = this.modalService.open(CreateNewModalComponent);
          this.modalRef.componentInstance.my_modal_content = 'something went wrong';
          this.modalRef.result.then((data: any) => {
          this.router.navigateByUrl('/forgot-password');
        });
        });
      }
  
    this.submitted = false;
  }

}
